import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import MultipleChoiceDropdown from 'app/components/multiple-choice-dropdown';

export default class CreateMultipleChoiceDropdown {
    constructor(multipleChoiceDropdown) {
        const container = multipleChoiceDropdown.find('[data-multiple-choice-dropdown-container]');
        const placeholder = container.data('multiple-choice-dropdown-placeholder');
        const createOptionLabel = container.data('multiple-choice-dropdown-create-option-label');
        const optionsData = container.data('multiple-choice-dropdown-choices');
        const formField = multipleChoiceDropdown.find(
            '[data-multiple-choice-dropdown-field] input'
        );
        const initialValue = formField.val();
        let options = this.buildOptions(optionsData, initialValue);

        ReactDOM.render(
            <MultipleChoiceDropdown
                options={options}
                initialValue={initialValue}
                placeholder={placeholder}
                createOptionLabel={createOptionLabel}
                onChange={this.handleChange.bind(this, formField)}
            />,
            container[0]
        );
    }

    buildOptions(optionsData, initialValue) {
        let selectedOptionArray = [];
        let options = [];

        if (initialValue !== '') {
            selectedOptionArray = initialValue.split(',');
        }

        options = Object.keys(optionsData).map(key => {
            return {
                label: optionsData[key],
                value: key,
            };
        });

        selectedOptionArray.forEach(option => {
            if (!optionsData.hasOwnProperty(option)) {
                options.push({
                    label: option,
                    value: option,
                });
            }
        });

        return options;
    }

    handleChange(formField, selectedArray) {
        let value = selectedArray
            .map(item => {
                return item.value;
            })
            .join(',');

        formField.val(value).trigger('change');
    }

    static create(selector) {
        $(selector).each((_, el) => {
            new CreateMultipleChoiceDropdown($(el));
        });
    }
}



// WEBPACK FOOTER //
// ./src/web/js/launch/modules/create-multiple-choice-dropdown.js